<div class="w-screen max-w-2xl font-inter">
  <div class="grid grid-cols-2 gap-5">
    <div class="flex flex-col">
      <div class="mb-2">Invoice #: {{ invoiceNumber }}</div>
      <div>Vendor Contract: {{ vendor }}</div>
    </div>
    <div class="flex flex-col">
      <div class="mb-2 text-xs">Upload invoice and supporting docs</div>
      <aux-file-manager
        #fileManager
        class="h-32"
        [eager]="false"
        [document_entity_id]="invoiceId"
        [document_entity_type_id]="INVOICE"
        [pathFn]="getFilePath"
      />
    </div>
  </div>

  @if ((loadingPreviousFiles$ | async) === true) {
    <div class="spinner m-auto mt-10 h-10 w-10 border-8"></div>
  }

  @if (files$ | async; as files) {
    @if (files?.length) {
      <div class="mt-4 grid max-h-[300px] grid-cols-12 overflow-y-auto">
        <div class="col-span-7 border-b-2 pb-2 text-xs">Uploaded Files</div>
        <div class="col-span-5 border-b-2 pb-2 text-xs">Designation</div>

        @for (file of files; track file) {
          <ng-container class="border-b">
            <div class="col-span-7 flex items-center break-all border-b p-2">
              {{ file.fileName }}
            </div>

            <div class="col-span-4 flex items-center border-b py-2">
              <div class="flex flex-1 items-center" [auxTooltip]="getTooltip(true, file)">
                <input
                  type="radio"
                  value="DOCUMENT_INVOICE"
                  class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                  [id]="file.id + 'inc'"
                  [name]="file.id"
                  [disabled]="isFilePdf(file) === false"
                  [(ngModel)]="documentTypes[file.id]"
                  (ngModelChange)="updateValidation.next(file)"
                />
                <label class="ml-3" [for]="file.id + 'inc'">
                  <span class="block text-sm font-medium text-gray-700">Invoice</span>
                </label>
              </div>

              <div class="flex flex-1 items-center" [auxTooltip]="getTooltip(undefined, file)">
                <input
                  type="radio"
                  value="DOCUMENT_INVOICE_SUPPORT"
                  class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                  [id]="file.id + 'sup'"
                  [name]="file.id"
                  [(ngModel)]="documentTypes[file.id]"
                  (ngModelChange)="updateValidation.next(file)"
                />
                <label class="ml-3" [for]="file.id + 'sup'">
                  <span class="block text-sm font-medium text-gray-700">Supporting Document</span>
                </label>
              </div>
            </div>

            <div class="flex justify-end border-b">
              <button class="p-2" type="button" (click)="removeFile(file)">
                <aux-icon name="Trash" class="text-aux-error" />
              </button>
            </div>
          </ng-container>
        }
      </div>
    }
  }
</div>
